<template>
<div>
    <invoice-form ref="invoiceForm"></invoice-form>
    <get-invoice-information-for-reminder-list-form ref="getInvoiceInformationForReminderListForm"></get-invoice-information-for-reminder-list-form>
    <context-menu ref="copyMenu"></context-menu>
    <b-row class="align-items-center mb-1">
        <b-col class="d-flex align-items-center col-lg-9">
            <b-col class="col-lg-3">
                <label for="aging-report-account-number-input"> {{ $t('agingReport.account_number') }} </label>
                <b-form-input id="aging-report-account-number-input" size="sm" v-model="accountNumber" v-on:keyup.enter="getAgingReportList()" :placeholder="$t('agingReport.account_number')" type="text" class="d-inline-block mr-1" />
            </b-col>
            <b-col class="col-lg-3">
                <label for="aging-report-agent-name-input"> {{ $t('agingReport.agent_name') }} </label>
                <b-form-input id="aging-report-agent-name-input" size="sm" v-model="agentName" v-on:keyup.enter="getAgingReportList()" :placeholder="$t('agingReport.agent_name')" type="text" class="d-inline-block mr-1" />
            </b-col>
            <b-col class="col-lg-3">
                <label for="aging-report-start-date-input"> {{ $t('agingReport.start_date') }} </label>
                <b-form-datepicker id="aging-report-start-date-input" today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('agingReport.start_date')" size="sm" v-model="startDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-lg-3">
                <label for="aging-report-end-date-input"> {{ $t('agingReport.end_date') }} </label>
                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('agingReport.end_date')" size="sm" v-model="endDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
        </b-col>
        <b-col class="col-md-3 custom-search d-flex justify-content-end mt-2">
            <div class="d-flex align-items-center">
                <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getAgingReportList()" @click="getAgingReportList()">{{ $t('agingReport.list') }}</b-button>
                <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="clearSearchForm">{{ $t('others.clear') }}</b-button>
            </div>
        </b-col>
    </b-row>
    <b-row class="mb-1">
        <b-col>
            <b-card class="p-2">
                <b-row>
                    <b-col class="col-lg-3">
                        <div class="text-center">
                            <div class="d-block font-weight-bold" style="font-size: 1.1em;">{{ $t('agingReport.acik_bakiye') || 'Open Balance' }} TRY</div>
                            <div class="d-block font-weight-bold" style="font-size: 1.2em; margin-top: 0.5rem;">₺ {{ $formatMoney(totalAmountOfTRYInvoices) }}</div>
                            <small class="d-block" style="margin-top: 0.5rem;">{{ totalCountOfTRYInvoices }} {{ $t('agingReport.fatura') || 'Invoice' }}</small>
                        </div>
                    </b-col>
                    <b-col class="col-lg-3">
                        <div class="text-center">
                            <div class="d-block font-weight-bold" style="font-size: 1.1em;">{{ $t('agingReport.acik_bakiye') || 'Open Balance' }} USD</div>
                            <div class="d-block font-weight-bold" style="font-size: 1.2em; margin-top: 0.5rem;">$ {{ $formatMoney(totalAmountOfUSDInvoices) }}</div>
                            <small class="d-block" style="margin-top: 0.5rem;">{{ totalCountOfUSDInvoices }} {{ $t('agingReport.fatura') || 'Invoice' }}</small>
                        </div>
                    </b-col>
                    <b-col class="col-lg-3">
                        <div class="text-center">
                            <div class="d-block font-weight-bold" style="font-size: 1.1em;">{{ $t('agingReport.acik_bakiye') || 'Open Balance' }} EUR</div>
                            <div class="d-block font-weight-bold" style="font-size: 1.2em; margin-top: 0.5rem;">€ {{ $formatMoney(totalAmountOfEURInvoices) }}</div>
                            <small class="d-block" style="margin-top: 0.5rem;">{{ totalCountOfEURInvoices }} {{ $t('agingReport.fatura') || 'Invoice' }}</small>
                        </div>
                    </b-col>
                    <b-col class="col-lg-3">
                        <div class="text-center">
                            <div class="d-block font-weight-bold" style="font-size: 1.1em;">{{ $t('agingReport.acik_bakiye') || 'Open Balance' }} GBP</div>
                            <div class="d-block font-weight-bold" style="font-size: 1.2em; margin-top: 0.5rem;">£ {{ $formatMoney(totalAmountOfGBPInvoices) }}</div>
                            <small class="d-block" style="margin-top: 0.5rem;">{{ totalCountOfGBPInvoices }} {{ $t('agingReport.fatura') || 'Invoice' }}</small>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <!-- Fast Filter Section -->
    <b-row class="mb-1">
        <b-col>
            <div class="fast-filter-section">
                <div class="filter-header">
                    <h6>{{ $t('agingReport.quick_filters') || 'Fast Filters' }}</h6>
                </div>
                <b-row>
                    <b-col class="col-lg-3">
                        <b-button :active="fastFilterId === 3" @click="applyAgingFilter(3)" :variant="fastFilterId === 3 ? 'primary' : 'outline-primary'" size="sm" class="w-100 fast-filter-btn">
                            <span class="filter-label">0-30 {{ $t('agingReport.invoices_days_count') || 'invoices_days_count' }}</span>
                            <b-badge variant="dark" class="ml-2">{{ countOfInvoices030DaysPassed }}</b-badge>
                        </b-button>
                    </b-col>
                    <b-col class="col-lg-3">
                        <b-button :active="fastFilterId === 4" @click="applyAgingFilter(4)" :variant="fastFilterId === 4 ? 'success' : 'outline-success'" size="sm" class="w-100 fast-filter-btn">
                            <span class="filter-label">31-60 {{ $t('agingReport.invoices_days_count') || 'invoices_days_count' }}</span>
                            <b-badge variant="dark" class="ml-2">{{ countOfInvoices3160DaysPassed }}</b-badge>
                        </b-button>
                    </b-col>
                    <b-col class="col-lg-3">
                        <b-button :active="fastFilterId === 5" @click="applyAgingFilter(5)" :variant="fastFilterId === 5 ? 'warning' : 'outline-warning'" size="sm" class="w-100 fast-filter-btn">
                            <span class="filter-label">61-90 {{ $t('agingReport.invoices_days_count') || 'invoices_days_count' }}</span>
                            <b-badge variant="dark" class="ml-2">{{ countOfInvoices6190DaysPassed }}</b-badge>
                        </b-button>
                    </b-col>
                    <b-col class="col-lg-3">
                        <b-button :active="fastFilterId === 6" @click="applyAgingFilter(6)" :variant="fastFilterId === 6 ? 'danger' : 'outline-danger'" size="sm" class="w-100 fast-filter-btn">
                            <span class="filter-label">+90 {{ $t('agingReport.invoices_days_count') || 'invoices_days_count' }}</span>
                            <b-badge variant="dark" class="ml-2">{{ countOfInvoicesMoreThan90DaysPassed }}</b-badge>
                        </b-button>
                    </b-col>
                </b-row>
                <b-row v-if="fastFilterId > 0" class="mt-1">
                    <b-col>
                        <small class="text-muted">
                            <b-button variant="link" size="sm" @click="clearAgingFilter" class="ml-2">{{ $t('others.clear') }}</b-button>
                        </small>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <app-collapse class="mb-1" accordion type="margin">
                <app-collapse-item :title="$t('others.search')">
                    <b-row>
                        <b-col class="col-lg-3">
                            <label for="aging-report-employee-input">{{ $t('agingReport.employee') }}</label>
                            <b-form-select v-model="employeeSelect" @change="getAgingReportList()" size="sm" value-field="id" text-field="name" :options="employeeOption" />
                        </b-col>
                        <b-col class="col-lg-3">
                            <label for="aging-report-start-total-input"> {{ $t('agingReport.start_total') }} </label>
                            <cleave id="aging-report-start-total-input" v-model="startTotal" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                        </b-col>
                        <b-col class="col-lg-3">
                            <label for="aging-report-end-total-input"> {{ $t('agingReport.end_total') }} </label>
                            <cleave id="aging-report-end-total-input" v-model="endTotal" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                        </b-col>
                        <b-col class="col-lg-3">
                            <label for="aging-report-currency-input">{{ $t('agingReport.currency') }}</label>
                            <b-form-select v-model="currencySelect" @change="getAgingReportList()" size="sm" value-field="id" text-field="code" :options="currencyOption" />
                        </b-col>
                    </b-row>
                </app-collapse-item>
            </app-collapse>
        </b-col>
    </b-row>
    <!-- Currency Statistics Summary -->

    <!-- table -->
    <vue-good-table id="agingReportTable" ref="agingReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
                enabled: true,
                externalQuery: searchTerm
              }" :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }" :pagination-options="{
                enabled: true,
                perPage: pageLength
              }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'debitNo'">
                {{ $t('agingReport.no') }}
            </span>
            <span v-else-if="props.column.field === 'agentName'" class="text-nowrap">
                {{ $t('agingReport.agent_name') }}
            </span>
            <span v-else-if="props.column.field === 'accountingNumber'">
                {{ $t('agingReport.account_number') }}
            </span>
            <span v-else-if="props.column.field === 'invoice_date'">
                {{ $t('agingReport.invoice_date') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('agingReport.currency') }}
            </span>
            <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                {{ $t('agingReport.total') }}
            </span>
            <span v-else-if="props.column.field === 'days'" class="text-nowrap">
                {{ $t('agingReport.days') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>

        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Debit No -->
            <span v-if="props.column.field === 'debitNo'" class="text-nowrap d-flex align-items-center">
                <span class="font-weight-500 mr-2">{{ props.row.debitNo }}</span>
            </span>
            <!-- Column: Days with Color Coding -->
            <span v-else-if="props.column.field === 'days'" class="text-nowrap">
                <b-badge :variant="getDaysVariant(props.row.days)" class="font-weight-bold">
                    {{ props.row.days }}
                </b-badge>
            </span>
            <!-- Column: Total (Right Aligned) -->
            <span v-else-if="props.column.field === 'total'" class="text-nowrap text-right d-block font-weight-500">
                {{ parseFloat(props.row.total).toFixed(2) }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                <b-badge variant="primary" :title="$t('others.show_invoice')" style="cursor: pointer;" @click="downloadInvoicePdf(props.row.invoiceId)" class="action-badge">
                    <feather-icon icon="FileTextIcon" size="5" class="align-middle" />
                </b-badge>
                <b-badge variant="info" :title="$t('invoiceReminder.info')" style="cursor: pointer;" class="ml-1 action-badge" @click="showReminderForm(props.row.invoiceId)">
                    <feather-icon icon="BellIcon" size="5" class="align-middle" />
                </b-badge>
                <b-badge variant="primary" :title="$t('invoiceReminder.send_mail')" style="cursor: pointer;" class="ml-1 action-badge" @click="showMailForm(props.row.invoiceId)">
                    <feather-icon icon="MailIcon" size="5" class="align-middle" />
                </b-badge>
            </span> </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select v-model="pageLength" :options="['10','25','50']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getAgingReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            dir: false,
            pageLength: 10,
            total: 0,
            pageNo: 1,
            name: '',
            accountNumber: '',
            startTotal: 0.0,
            endTotal: 0.0,
            startDate: null,
            endDate: null,
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2
            },
            columns: [{
                    label: this.$t('agingReport.no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('agingReport.invoice_date'),
                    field: `invoiceDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('agingReport.agent_name'),
                    field: `agentName`,
                },
                {
                    label: this.$t('agingReport.account_number'),
                    field: `accountingNumber`,
                },
                {
                    label: this.$t('agingReport.currency'),
                    field: `currency`,
                },
                {
                    label: this.$t('agingReport.total'),
                    field: `total`,
                    formatFn: (value) => parseFloat(value).toFixed(2)
                },
                {
                    label: this.$t('agingReport.days'),
                    field: `days`,
                },
                {
                    label: this.$t('others.process'),
                    field: `process`,
                }
            ],
            rows: [],
            searchTerm: '',
            employeeSelect: 0,
            employeeOption: [],
            moduleSelect: 0,
            moduleOption: [],
            currencySelect: 0,
            currencyOption: [],
            agentName: "",
            totalAmountOfTRYInvoices: 0,
            totalCountOfTRYInvoices: 0,
            totalAmountOfUSDInvoices: 0,
            totalCountOfUSDInvoices: 0,
            totalAmountOfEURInvoices: 0,
            totalCountOfEURInvoices: 0,
            totalAmountOfGBPInvoices: 0,
            totalCountOfGBPInvoices: 0,
            countOfInvoices030DaysPassed: 0,
            countOfInvoices3160DaysPassed: 0,
            countOfInvoices6190DaysPassed: 0,
            countOfInvoicesMoreThan90DaysPassed: 0,
            fastFilterId: 0,
        }
    },
    mounted() {
        this.startDate = new Date('2024-01-01').toJSON();
        this.getAgingReportList()
    },
    methods: {
        showMailForm(invoiceId) {
            //TODO: Implement the logic to show the mail form for the given invoiceId
        },
        openContextMenu(event, row) {
            this.$refs.copyMenu.openContextMenu(event, row)
        },
        getAgingReportList() {
            this.rows = []
            const controller = {
                name: 'Invoice',
                actionName: 'GetInvoiceAgingReportList'
            }
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                name: this.name,
                agentName: this.agentName,
                accountingNo: this.accountNumber,
                debitNote: this.debitNote,
                startTotal: this.startTotal,
                endTotal: this.endTotal,
                startDate: this.startDate,
                endDate: this.endDate,
                moduleId: this.molduleSelect,
                employeeId: this.employeeSelect,
                currencyId: this.currencySelect,
                fastFilterId: this.fastFilterId
            }
            const payload = {
                controller: controller,
                data: data
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.moduleOption = response.data.moduleList
                    this.employeeOption = response.data.employeeList
                    this.currencyOption = response.data.currencyList
                    this.moduleOption.splice(0, 0, this.$nullSelected())
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                    this.currencyOption.splice(0, 0, this.$nullSelected('code'))
                    this.total = response.data.total
                    this.totalAmountOfTRYInvoices = response.data.totalAmountOfTRYInvoices
                    this.totalCountOfTRYInvoices = response.data.totalCountOfTRYInvoices
                    this.totalAmountOfUSDInvoices = response.data.totalAmountOfUSDInvoices
                    this.totalCountOfUSDInvoices = response.data.totalCountOfUSDInvoices
                    this.totalAmountOfEURInvoices = response.data.totalAmountOfEURInvoices
                    this.totalCountOfEURInvoices = response.data.totalCountOfEURInvoices
                    this.totalAmountOfGBPInvoices = response.data.totalAmountOfGBPInvoices
                    this.totalCountOfGBPInvoices = response.data.totalCountOfGBPInvoices
                    this.countOfInvoices030DaysPassed = response.data.countOfInvoices030DaysPassed
                    this.countOfInvoices3160DaysPassed = response.data.countOfInvoices3160DaysPassed
                    this.countOfInvoices6190DaysPassed = response.data.countOfInvoices6190DaysPassed
                    this.countOfInvoicesMoreThan90DaysPassed = response.data.countOfInvoicesMoreThan90DaysPassed
                    response.data.invoiceAgingReportList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        getShowInvoiceForm(id) {
            this.$refs.invoiceForm.showInfo(id)
        },
        async downloadInvoicePdf(id) {
            const data = {
                invoiceId: id
            }
            const controller = {
                name: 'Invoice',
                actionName: 'DownloadProforma'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(response.data.document.name, response.data.base64, response.data.document.type)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        showReminderForm(invoiceId) {
            this.$refs.getInvoiceInformationForReminderListForm.showInfo(invoiceId)
        },
        exportExcel() {
            let controller = {
                name: 'Invoice',
                actionName: 'GetInvoiceAgingReportList'
            }
            let data = {
                pageLength: 5000,
                pageNo: 1,
                name: this.name,
                agentName: this.agentName,
                accountingNo: this.accountNumber,
                debitNote: this.debitNote,
                startTotal: this.startTotal,
                endTotal: this.endTotal,
                startDate: this.startDate,
                endDate: this.endDate,
                moduleId: this.molduleSelect,
                employeeId: this.employeeSelect,
                currencyId: this.currencySelect,
                fastFilterId: this.fastFilterId
            }
            let payload = {
                controller: controller,
                data: data
            }

            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    controller = {
                        name: 'Invoice',
                        actionName: 'CanExport'
                    }
                    data = {
                        columnList: this.columns,
                        DataList: response.data.invoiceAgingReportList
                    }
                    payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$downloadFile("InvoiceAgingReport", response.data.base64, 'xlsx')
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        clearSearchForm() {
            this.accountNumber = '';
            this.agentName = '';
            this.startDate = null;
            this.endDate = null;
            this.employeeSelect = 0;
            this.currencySelect = 0;
            this.startTotal = 0.0;
            this.endTotal = 0.0;
            this.getAgingReportList();
        },
        getDaysVariant(days) {
            if (days >= 31 && days <= 60) {
                return 'success'; // Green
            } else if (days >= 61 && days <= 90) {
                return 'warning'; // Yellow
            } else if (days > 90) {
                return 'danger'; // Red for 90+
            }
        },
        applyAgingFilter(filterId) {
            this.fastFilterId = filterId;
            this.pageNo = 1;
            this.getAgingReportList();
        },
        clearAgingFilter() {
            this.fastFilterId = 0;
            this.pageNo = 1;
            this.getAgingReportList();
        }
    },
}
</script>

<style lang="scss" scoped>
.mr-05 {
    margin-right: 0.5rem !important;
}

.custom-search {
    .btn {
        margin-left: 5px;
    }
}

.fast-filter-section {
    background: linear-gradient(135deg, #f5f7fa 0%, #fafbfc 100%);
    border: 1px solid #e8eaed;
    border-radius: 0.5rem;
    padding: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .filter-header {
        margin-bottom: 1rem;

        h6 {
            color: #34495e;
            font-weight: 600;
            margin: 0;
            text-transform: uppercase;
            font-size: 0.875rem;
            letter-spacing: 0.5px;
        }
    }

    .fast-filter-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 1rem !important;
        height: 2.5rem;
        transition: all 0.3s ease;
        border-weight: 2px;

        .filter-label {
            font-weight: 500;
            font-size: 0.9rem;
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        &.active {
            font-weight: 600;
        }
    }

    .b-badge {
        font-size: 0.9rem;
        padding: 0.35rem 0.6rem;
        font-weight: 700;
        background-color: rgba(52, 73, 94, 0.95) !important;
        color: #fff !important;
        border-radius: 0.25rem;
        min-width: 2.5rem;
        text-align: center;
        display: inline-block;
    }
}

.action-badge {
    padding: 0.4rem 0.5rem !important;
    transition: all 0.2s ease !important;
    border-radius: 0.35rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    &:active {
        transform: scale(0.95);
    }
}
</style>
